import { Component, Input, OnInit } from '@angular/core';
import { TenantDashboardChartId } from 'app/library/tenant-dashboard/enums/tenant-dashboard-chart-id.enum';
import { TenantDashboard } from 'app/library/tenant-dashboard/models/tenant-dashboard';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';

@Component({
    selector: 'app-monthly-active-days',
    templateUrl: './monthly-active-days.component.html',
    styleUrls: ['./monthly-active-days.component.scss'],
})
export class MonthlyActiveDaysComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    hideChartTitle: boolean;

    @Input()
    charts: TenantDashboard[];

    @Input()
    yearlyActiveDays: number;

    TenantDashboardChartId = TenantDashboardChartId;

    constructor() {
        super();
    }

    async ngOnInit(): Promise<void> {}
}
